import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectUnits } from "shared/slice/unitsSlice";
import { convertCelsiusToFahrenheit } from "shared/helpers/helpers";

export const useSetAndCurrentTemp = (machineData) => {
    const { isF } = useSelector(selectUnits);

    const instantHeatReady = Boolean(machineData?.instantHeat?.isReady);
    const optionalConstantReady = Boolean(machineData?.optionalConstantTemp?.isReady);
    const heatingScheduleActivated = Boolean(machineData?.heatingSchedule?.isActivated);
    const snowSensorReady = Boolean(machineData?.snowSensor?.isReady);
    const snowSensorActivated = Boolean(machineData?.snowSensor?.isActivated);
    const windFactorReady = Boolean(machineData?.windFactor?.isReady);
    const windFactorActivated = Boolean(machineData?.windFactor?.isActivated);
    const hasActiveTempProgram =
        instantHeatReady ||
        optionalConstantReady ||
        heatingScheduleActivated ||
        (snowSensorReady && snowSensorActivated) ||
        (windFactorReady && windFactorActivated);

    const setTemp = useMemo(() => {
        if (!machineData?.thermocouple || machineData?.setTemp == null || !hasActiveTempProgram) return '--';
        return isF ? convertCelsiusToFahrenheit(machineData.setTemp) : machineData.setTemp;
    }, [
        hasActiveTempProgram,
        isF,
        machineData?.setTemp,
        machineData?.thermocouple
    ]);

    const currentTemp = useMemo(() => {
        if (!machineData?.thermocouple || machineData?.currentTemp == null || !hasActiveTempProgram) return '--';
        return isF ? convertCelsiusToFahrenheit(machineData.currentTemp) : machineData.currentTemp;
    }, [hasActiveTempProgram, isF, machineData?.currentTemp, machineData?.thermocouple]);

    return { setTemp, currentTemp }
}
